import { render, staticRenderFns } from "./OnlyTextMedia.vue?vue&type=template&id=bd2cc446&scoped=true&"
import script from "./OnlyTextMedia.vue?vue&type=script&lang=js&"
export * from "./OnlyTextMedia.vue?vue&type=script&lang=js&"
import style0 from "./OnlyTextMedia.vue?vue&type=style&index=0&id=bd2cc446&prod&lang=less&"
import style1 from "./OnlyTextMedia.vue?vue&type=style&index=1&id=bd2cc446&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2cc446",
  null
  
)

export default component.exports